import { memo } from 'react';
import { TextField, Grid2, Typography } from '@mui/material';

interface SettingsFormFieldProps {
    label: string;
    value: string;
    onChange?: React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>
    type?: 'text' | 'email' | 'password' | 'tel' | 'number';
    loading?: boolean;
    error?: string;
    fullWidth?: boolean;
    placeholder?: string;
    onBlur?: () => void;
    onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
    slotProps?: {
        input?: {
            endAdornment?: React.ReactNode;
        };
    };
}

const SettingsFormField = memo(({
    label,
    value,
    onChange,
    onBlur,
    type = 'text',
    loading = false,
    error,
    fullWidth = true,
    onKeyDown,
    slotProps,
    placeholder
}: SettingsFormFieldProps) => {    
    return (
        <Grid2 container size={12} direction="column" spacing={1}>
            <Grid2>
                <Typography 
                    variant="body2" 
                    color="semantic.text.dimmed"
                    sx={{ 
                        fontSize: '0.9rem',
                        mb: 0.5
                    }}
                >
                    {label}
                </Typography>
            </Grid2>
            <Grid2>
                <TextField
                    type={type}
                    value={value}
                    onChange={onChange}
                    onBlur={onBlur}
                    onKeyDown={onKeyDown}
                    disabled={loading}
                    error={!!error}
                    helperText={error}
                    fullWidth={fullWidth}
                    placeholder={placeholder}
                    slotProps={{
                        ...slotProps,
                        input: {
                            ...slotProps?.input,
                            sx: {
                                bgcolor: 'semantic.surface.input',
                                '&.Mui-disabled': {
                                    bgcolor: "semantic.text.paragraph"
                                }
                            }
                        }
                    }}
                />
            </Grid2>
        </Grid2>
    );
});

export default SettingsFormField;